import { useMemo } from 'react';
import { useSelectedStationCode } from 'store/features/station';

import { Stations } from 'dataSources/Typicode/stations';
import { HereLayer } from 'common/utils/MapMarker/types';

import { getIcon } from '../utils';

import { EMPTY_ARRAY } from 'shared/constants';

interface ExtraStationMarkersLayerProps {
  extraStations?: Stations;
}

export const useFoundedPlaceLayer = ({
  extraStations
}: ExtraStationMarkersLayerProps) => {
  const selectedStationCode = useSelectedStationCode();

  const foundedPlaceLayer = useMemo((): HereLayer => ({
    data: extraStations || EMPTY_ARRAY,
    name: 'extra-stations',
    type: 'cluster',
    getCoordinates: ({ data: { coordinates: {
      latitude,
      longitude
    } } }: any) => ({
      latitude,
      longitude
    }),
    getIcon: (iconProps: any) => getIcon({
      ...iconProps,
      selectedStation: selectedStationCode
    })
  }), [
    extraStations,
    selectedStationCode
  ]);

  return foundedPlaceLayer;
};